import { SafetyInspectionFacility, SafetyInspectionLocation } from "../DTOs";

export type InspectionSummary = 
{
    state:  'no-inspections' | 
            'not-started' |
            'in-progress' | 
            'completed',
    passed: number,
    failed: number,
    pending: number,
    total: number,
}

export const safetyInspectionSummaryHelper = {
    getLocationInspectionSummary,
    getFacilityInspectionSummary
}

function getLocationInspectionSummary (location: SafetyInspectionLocation): InspectionSummary
{
    const locationSummary:InspectionSummary = {
        state: 'no-inspections',
        passed: 0,
        failed: 0,
        pending: 0,
        total: 0
    }

    for(const f of location.facilities){
        const facilitySummary = getFacilityInspectionSummary(f);
        locationSummary.passed += facilitySummary.passed;
        locationSummary.failed += facilitySummary.failed;
        locationSummary.pending += facilitySummary.pending;
        locationSummary.total += facilitySummary.total;
    }

    if(locationSummary.total > 0)
    {
        if(locationSummary.pending === locationSummary.total)
            locationSummary.state = 'not-started';
        else if(locationSummary.pending > 0)
            locationSummary.state = 'in-progress';
        else {
            locationSummary.state = 'completed';
        }
    }

    return locationSummary;
}

function getFacilityInspectionSummary (facility: SafetyInspectionFacility): InspectionSummary
{
    const summary:InspectionSummary = {
        state:'no-inspections',
        pending: 0,
        passed: 0,
        failed: 0,
        total: 0
    }

    for(const i of facility.inspectionPoints){
        if(i.inspectionResult.status === 'passed') summary.passed++;
        if(i.inspectionResult.status === 'failed') summary.failed++;
        if(i.inspectionResult.status === 'pending') summary.pending++;
        summary.total++;
    }

    if(summary.total > 0)
    {
        if(summary.pending === summary.total)
            summary.state = 'not-started';
        else if(summary.pending > 0)
            summary.state = 'in-progress';
        else {
            summary.state = 'completed';
        }
    }

    return summary;
}